import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Box, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import AnchorPopper from "../../../../../../components/forms/AnchorPopper";
import {
  getTextFieldInputProps,
  StyledTextField,
  textFieldLabelProps,
} from "../../../../../../components/forms/styles/formFieldStyles";

const JiraIssueType = ({
  options,
  showOptions,
  selectedOption,
  setSelectedOption,
}) => {
  const { errors, touched, handleBlur, setFieldValue } = useFormikContext();

  const handleChange = (_, newValue) => {
    setSelectedOption(newValue);
    setFieldValue("issueType", newValue);
  };

  const hasError = !!touched.issueType && !!errors.issueType;
  const errorMessage =
    hasError && typeof errors.issueType === "string" ? errors.issueType : "";

  const issueTypeLabel = useMemo(() => {
    const labelText = selectedOption ? "Issue type" : "Select issue type";

    return <Typography variant="caption">{labelText}</Typography>;
  }, [selectedOption]);

  return (
    <Autocomplete
      options={options || []}
      disabled={!showOptions}
      getOptionLabel={(option) => option.name}
      value={selectedOption}
      onChange={handleChange}
      popupIcon={<ExpandMoreIcon />}
      PopperComponent={AnchorPopper}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          <Typography variant="caption">{option.name}</Typography>
        </Box>
      )}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          margin="dense"
          label={issueTypeLabel}
          fullWidth
          required
          error={hasError}
          helperText={errorMessage}
          onBlur={handleBlur}
          InputProps={getTextFieldInputProps(params.InputProps)}
          InputLabelProps={textFieldLabelProps(params.InputLabelProps)}
        />
      )}
    />
  );
};
export default JiraIssueType;
